export default __webpack_public_path__ + "23b6e57df71ae5f994cf0ccaaf1a4024.jpg";